import React from 'react';

const NotFoundPage = () => {
    return (
        <div className='container text-center mt-5'>
            <h1>404</h1>
            <p>صفحه مورد نظر یافت نشد!</p>
        </div>
    );
};

export default NotFoundPage;
